<template>
  <div>
    <h3 class="mb-5">Description</h3>
    <div class="h4 mb-5">可自行新檔案描述</div>

    <!-- itemList -->
    <PageCollapse v-for="(item, i) in download.descriptions" :key="i">
      <template v-slot:head>
        <h3>描述 {{ i + 1 }}</h3>
      </template>
      <template v-slot:actions>
        <div class="ml-auto">
          <button class="btn square mr-10px" @click="deleteItem(item)">
            <v-icon class="ink-02-medium--text">delete</v-icon>
          </button>
          <button class="btn square mr-10px" @click="downItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
          </button>
          <button class="btn square" @click="upItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <!-- 標題 -->
        <div class="form-item d-flex py-5">
          <div class="w-180px mr-5">
            <h4>標題</h4>
          </div>
          <div class="flex-grow-1 flex-basis-0 my-n2">
            <v-text-field
              v-model="item.title"
              outlined
              dense
            ></v-text-field>
          </div>
        </div>

        <!-- 內文 -->
        <div class="form-item d-flex py-5">
          <div class="w-180px mr-5">
            <h4>內文</h4>
          </div>
          <div class="flex-grow-1 flex-basis-0 my-n2">
            <editor
              :key="item.id"
              v-model="item.content"
              :plugins="'link image'"
              :toolbar="'link bold image'"
            />
          </div>
        </div>
        <!-- banner type = Video, upload type = 自電腦上傳影片 -->
        <div v-if="item.upload_type == 'file'">
          <!-- 影片上傳 -->
          <div class="form-item d-flex px-5 pt-5 pb-5">
            <div class="w-200px">
              <h4 class="mb-10px">影片</h4>
              <div class="h5 ink-02-medium--text">
                影片支援格式：.mp4, .mov, .avi <br />
                檔案大小限制：&lt; 10 MB
              </div>
            </div>
            <div class="d-flex justify-end flex-grow-1">
              <FileUploader
                v-model="item.url"
                :dir="'support'"></FileUploader>
            </div>
          </div>
        </div>

        <!-- upload type -->
        <div class="form-item d-flex pb-5 mt-5 align-center">
          <h4 class="w-180px mr-35px">UploadType</h4>
          <div class="flex-grow-1">
            <v-radio-group v-model="item.upload_type" row>
              <div
                v-for="uploadType in [
                    {
                      label: '自電腦上傳影片',
                      value: 'file',
                    },
                    {
                      label: '來自Youtube/Youku連結',
                      value: 'link',
                    },
                  ]"
                :key="uploadType.value"
                class="w-50"
              >
                <v-radio class="mr-01" :value="uploadType.value">
                  <template v-slot:label>
                    <div class="ink-01-emphasis--text w-202px">
                      {{ uploadType.label }}
                    </div>
                  </template>
                </v-radio>
              </div>
            </v-radio-group>
          </div>
        </div>

        <!-- banner type = Video, upload type = 來自Youtube/Youku連結 -->
        <div v-if="item.upload_type == 'link'">
          <!-- Youtube -->
          <label class="form-item d-flex">
            <h4 class="w-180px my-5 mr-6">影片連結</h4>
            <div class="flex-grow-1 my-3">
              <div class="form-input-group">
                <div class="prepend-icon" style="top: 45%;">
                  <v-icon>link</v-icon>
                </div>
                <input
                  type="text"
                  class="pl-42px"
                  style="top: 45%"
                  v-model="item.url"
                />
              </div>
            </div>
          </label>
          <!-- Youku -->
          <!--<label class="form-item px-5 d-flex">-->
          <!--<h4 class="w-180px my-5 mr-6">Youku</h4>-->
          <!--<div class="flex-grow-1 my-3">-->
          <!--<div class="form-input-group">-->
          <!--<div class="prepend-icon" style="top: 45%;">-->
          <!--<v-icon>link</v-icon>-->
          <!--</div>-->
          <!--<input type="text" class="pl-42px" v-model="item.youkuUrl" />-->
          <!--</div>-->
          <!--</div>-->
          <!--</label>-->
        </div>

        <!-- img upload -->
        <div class="d-flex px-5 pt-5 mb-8">
          <div class="w-180px">
            <h4 class="mb-10px">Preview Image</h4>
            <div class="h5 ink-02-medium--text">
              建議尺寸：999px * 999px <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <ImgUploader
              :imageUrl.sync="item.preview_image"
              :dir="'support'"></ImgUploader>
          </div>
        </div>
      </template>
    </PageCollapse>

    <!-- add team sponsorship -->
    <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addItem">
        <v-icon class="primary--text mr-2">add_circle</v-icon>
        <span>添加描述</span>
      </button>
    </div>
  </div>
</template>

<script>
import ImgUploader from '@/components/ImgUploader.vue';
import PageCollapse from '@/components/PageCollapse.vue';
import Editor from '@/components/TinymceEditor.vue';
import FileUploader from '@/components/FileUploader.vue';

export default {
  props: {
    download: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ImgUploader,
    PageCollapse,
    Editor,
    FileUploader,
  },
  methods: {
    addItem() {
      const template = {
        id: null,
        title: '',
        content: '',
        upload_type: 'file',
        url: '',
        preview_image: null,
      };
      this.download.descriptions.push(template);
    },
    deleteItem(item) {
      const index = this.download.descriptions.map((option) => option.id).indexOf(item.id);
      this.download.descriptions.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.download.descriptions.length - 1) {
        this.download.descriptions.splice(i, 1);
        this.download.descriptions.unshift(item);
        return;
      }
      // item become next index
      this.download.descriptions.splice(i, 1);
      this.download.descriptions.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.download.descriptions.splice(i, 1);
        this.download.descriptions.push(item);
        return;
      }
      // item become previous index
      this.download.descriptions.splice(i, 1);
      this.download.descriptions.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
